let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cfJp1")).then(() => parcelRequire('4yDJ1'));